import {
  Box, Button, Flex,
  Image, Text
} from "@chakra-ui/react";
import React from "react";
import {matchRoutes, useLocation, useNavigate} from "react-router-dom";

import {useAuthentication} from "../shared/hooks/AuthenticationProvider";
import {Authority, Paths, whiteAvataiButtonProps} from "../shared/model/Constants";

const Header = () => {
  const authentication = useAuthentication();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  function navigateHome() {
    navigate(Paths.HOME);
  }

  function loggedIn(){
    return (authentication.currentUserQuery && (!authentication.currentUserQuery.isError &&
      authentication.currentUserQuery.data?.status !== 401))
  }

  function loggedInAs(authority: Authority){
    return (authentication.currentUserQuery && (!authentication.currentUserQuery.isError &&
        authentication.currentUserQuery.data?.status !== 401) &&
      authentication.currentUserQuery.data?.data?.authorities?.includes(authority))
  }

  const isTest = matchRoutes([{path:Paths.TESTS_PUBLIC_ID}], pathname) ||
      matchRoutes([{path:Paths.SPEECH_TEST}], pathname) ||
      matchRoutes([{path:Paths.AUTOMATED_TEST}], pathname);
  return (
    <>{
      <>
        <Box bg="white" paddingBlock="1em">
          <Flex justify="space-evenly" align="center">
            <Image src="/images/LogoUCR.png" height="116px" width="300px"/>
            <Image src="/images/LogoELM.png"  height="60px" width="360px"/>
            <Image src="/images/LogoLangInc.png"  height="130px" width="200px"/>
          </Flex>
        </Box>
        <Box bg="#004AAD" paddingY="0.5em">
          <Flex align="center" flexWrap="wrap" justifyContent="flex-start">
            { loggedIn() ?
              <>
                <Text color="white" paddingX={10}>
                  {authentication.currentUserQuery?.data?.data?.name}
                </Text>
                { loggedInAs(Authority.ROLE_ADMIN) &&
                  <Box>
                    <Button
                      {...whiteAvataiButtonProps} onClick={()=>navigate(Paths.ADMIN)}>
                      Administrador
                    </Button>
                  </Box>
                }
                { !isTest && loggedInAs(Authority.ROLE_TEACHER) &&
                  <Box>
                    <Button
                      {...whiteAvataiButtonProps} onClick={()=>navigate(Paths.TEACHER_LICENSES_INST)}>
                      Ver licencias
                    </Button>
                  </Box>
                }
                { !isTest &&  loggedInAs(Authority.ROLE_TEACHER) &&
                  <Box paddingLeft={10}>
                    <Button
                      {...whiteAvataiButtonProps} onClick={()=>navigate(Paths.TEACHER_CANDIDATES)}>
                      Ver progreso
                    </Button>
                  </Box>
                }
                <Box paddingLeft={10}>
                  <Button
                    {...whiteAvataiButtonProps} onClick={navigateHome}>
                    Inicio
                  </Button>
                </Box>{ !isTest &&
                <Box paddingLeft={10}>
                  <Button colorScheme="gray"
                          onClick={() => authentication.logoutMutation?.mutate(null)}>
                    Cerrar sesión
                  </Button>
                </Box>
                }
              </>
              : <> { matchRoutes([{path:Paths.ERROR}], pathname) &&
                <Box paddingX={10}>
                  <Button colorScheme="teal" onClick={navigateHome}>
                    Inicio
                  </Button>
                </Box>
              }
              </>
            }
          </Flex>
        </Box>
        <Box bg="#FDB912" height="1em"/>

      </>}
    </>
  );
};

export default Header;
